'use strict';

export const Constants = Object.freeze({
  INVALID_LINK_REDIRECT_URLS: {
    LINK_INVALID: 'link-invalid',
    ACCOUNT_LOCKED: 'profile-locked',
    LINK_EXPIRED: 'link-expired',
  },
});
